// src/pages/checklists/CalendarioChecklistsPage.jsx
import React, { useState } from "react";
import { useTheme } from "../../contexts/ThemeContext";
import { useIsMobile } from "../../hooks/useIsMobile";
import LayoutDesktop from "../../layouts/LayoutDesktop";
import LayoutMobile from "../../layouts/LayoutMobile";

export default function CalendarioChecklistsPage() {
  const { tema, alterarTema } = useTheme();
  const isMobile = useIsMobile(900);
  const [sidebarAberta, setSidebarAberta] = useState(false);

  const conteudo = (
    <section className="pc-card">
      <h2 style={{ marginTop: 0 }}>Calendário de checklists</h2>
      <p style={{ marginTop: 8, lineHeight: 1.5 }}>
        Visão em calendário para planejar e acompanhar checklists (ex.: instalação,
        inspeções e rotinas).
      </p>
      <div style={{ marginTop: 12, fontSize: 13, opacity: 0.9 }}>
        (MVP) Tela preparada para receber a agenda/calendário no mesmo padrão de
        Preventivas.
      </div>
    </section>
  );

  if (isMobile) {
    return (
      <LayoutMobile
        tema={tema}
        alterarTema={alterarTema}
        titulo="Calendário de Checklists"
        sidebarAberta={sidebarAberta}
        onToggleSidebar={() => setSidebarAberta((v) => !v)}
        abaBottom="home"
      >
        {conteudo}
      </LayoutMobile>
    );
  }

  return (
    <LayoutDesktop
      tema={tema}
      titulo="Calendário de Checklists"
      subtitulo="Checklist / Calendário"
    >
      {conteudo}
    </LayoutDesktop>
  );
}
